// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/metar-taf-comparison.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/metar-taf-comparison/metar-taf-comparison.js';

mount([g0]);
